import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';

import { BillingPanelProps } from './BillingPanel.props';
import { FieldGrid, FieldItem } from '../../../../../components/atoms/FieldGrid';
import { Panel } from '../../../../../components/atoms/Panel';

const formatCurrency = (value?: number): string =>
  value != null ? `$${value.toFixed(2)}` : '$0.00';

export const BillingPanel: React.FC<BillingPanelProps> = ({
  billing = {},
}) => {
  const addButton = (
    <Button
      size="small"
      startIcon={<AddIcon />}
      sx={{ fontSize: '12px', textTransform: 'none' }}
    >
      Add Line Item
    </Button>
  );

  return (
    <Panel title="Billing" actions={addButton}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FieldGrid columns={2}>
          <FieldItem
            label="Labour Cost"
            value={formatCurrency(billing.labourCost)}
          />
          <FieldItem
            label="Parts Cost"
            value={formatCurrency(billing.partsCost)}
          />
          <FieldItem
            label="Callout Fee"
            value={formatCurrency(billing.calloutFee)}
          />
          <FieldItem
            label="Total"
            value={
              <Typography
                component="span"
                sx={{ fontSize: '15px', fontWeight: 700 }}
              >
                {formatCurrency(billing.total)}
              </Typography>
            }
          />
        </FieldGrid>
      </Box>
    </Panel>
  );
};
